import BRAND from '../brand'
import tf_logo from '../assets/images/logo_tf_horizontal.svg'
import './PoweredBy.css'

// "Powered by thefaculty": only in the brands that ask for it
export default function PoweredBy({className = ''}) {
    if (!BRAND.poweredBy) return null
    return (
        <div className={`powered_by ${className}`}>
            <span>Powered by</span>
            <img src={tf_logo} alt="thefaculty" />
        </div>
    )
}
